import React, { Component } from "react";
import { TransitionGroup } from "react-transition-group";
import { animateScroll } from "react-scroll";
import { connect } from "react-redux";
import { saveUID, saveProfile, saveUsers } from "../../redux/actions";
import MessageItem from "../../components/MessageItem";
import MessageInput from "../../components/MessageInput";
import Firebase from "../../firebasehelper";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import {
  getBotMessageGroup,
  getBetweenTimeoutValue,
  getTimeoutValue,
  getInputTimeoutValue,
  addBotMessageGroup,
} from "../../Utils/botMessages";
import { getUserMessage, addUserMessage } from "../../Utils/userMessages";
import "./index.css";
const logoImg = require("../../assets/media/ecosystem_logo.png");
class SignUp extends React.Component {
  state = {
    showInput: false,
    messages: [],
    name: "",
    isIphoneX: true,
    username: "",
    total_brands: [],
  };
  constructor(props) {
    super(props);
    this.messages = [
      {
        type: "user",
        message: "Hello",
      },
    ];
  }
  componentDidMount() {
    this.checkDeviceStatus();
    window.addEventListener("resize", this.checkDeviceStatus);
    this.getBotMessageGroup();
    Firebase.getAllBrands((res) => {
      let total_brands = res
        .map((item, index) => {
          let new_item = item;
          new_item.id = index;
          return new_item;
        })
        .filter((item) => item && !item.deactive);
      console.log("total_brands", total_brands);
      this.setState({ total_brands });
    });
  }
  checkDeviceStatus = () => {
    this.setState({ ismobile_pad: window.innerWidth < 1024 });
  };
  getBotMessageGroup = () => {
    this.setState({
      showInput: false,
    });
    const messageGroup = getBotMessageGroup();

    if (messageGroup) {
      messageGroup.forEach((message, index) => {
        const timeoutValue =
          getTimeoutValue() + (index ? index * getBetweenTimeoutValue() : 0);
        setTimeout(() => {
          this.setMessageInState(message);
          this.scrollToBottom();
          if (index === messageGroup.length - 1) this.toggleUserInput(true);
        }, timeoutValue);
      });
    }
  };

  scrollToBottom(delay = 0) {
    if (delay) {
      setTimeout(() => {
        animateScroll.scrollToBottom({
          duration: 500,
          smooth: "easeInOutQuad",
        });
      }, delay);
    } else {
      animateScroll.scrollToBottom({
        duration: 500,
        smooth: "easeInOutQuad",
      });
    }
  }

  setMessages() {
    const { logo } = this.props;
    const { messages } = this.state;
    return messages.map((message, i) => {
      const firstChild = i !== 0 && messages[i - 1].type !== message.type;
      return (
        <MessageItem
          message={message}
          firstChild={firstChild}
          key={i}
          timeoutValue={getTimeoutValue(message.message)}
          logo={logo}
          imageIndex={i % 2}
        />
      );
    });
  }
  toggleUserInput(timeout) {
    console.log("toggle UserInput");
    if (!this.state.showInput) this.scrollToBottom(500);
    const { userMessage } = this.state;
    const showInput = !this.state.showInput;
    if (timeout) {
      setTimeout(() => {
        if (!this.state.showInput) this.scrollToBottom(500);
        this.setState({
          showInput,
          userMessage: showInput ? getUserMessage() : userMessage,
        });
      }, getInputTimeoutValue());
    } else {
      this.setState({
        showInput,
        userMessage: showInput ? getUserMessage() : userMessage,
      });
    }
  }

  setMessageInState(message) {
    const messages = this.state.messages.slice();
    messages.push(message);
    this.setState({ messages });
  }

  addMessage = (message) => {
    if (message.key === "firstname") {
      setTimeout(() => {
        this.scrollToBottom();
        let name = message.message;
        this.setState({ username: name });
        addBotMessageGroup([
          {
            type: "bot",
            message: `Thanks ${name}, I need to take your email so we can register an account for your brand.`,
          },
          {
            type: "bot",
            message:
              "Once your details have been reviewed by us, we will create an account for you and send you a temporary password to your email.",
          },
        ]);
        this.getBotMessageGroup();
      }, getBetweenTimeoutValue());
    } else if (message.key === "brand") {
      setTimeout(() => {
        this.scrollToBottom();
        let brand = message.message;
        addBotMessageGroup([
          {
            type: "bot",
            message: `<b>${brand}</b> is a great name. Now I need a version of your logo so we can start customizing your content.`,
          },
          {
            type: "bot",
            message: `If you have a png version without a background this would be splendid...?`,
          },
        ]);
        this.getBotMessageGroup();
      }, getBetweenTimeoutValue());
    } else {
      if (!message.finish) {
        setTimeout(() => {
          this.getBotMessageGroup();
        }, 1000);
      }
    }
    this.setMessageInState(message);
    this.toggleUserInput();
  };
  // This function is a bug fix to the very first chat input box not appearing at the bottom of the screen
  // All other chat input boxes behave as expected.
  applyHeight = () => {
    const vh100Class = "message-list-wrapper--100vh";
    const fullScreenClass = "message-list-wrapper--100pct";

    const el = document.getElementsByClassName("message-list-wrapper")[0];
    const numChildren = el.childElementCount;

    if (numChildren <= 6 && !el.classList.contains(vh100Class)) {
      el.classList.add(vh100Class);
    } else if (numChildren > 6 && !el.classList.contains(fullScreenClass)) {
      el.classList.remove(vh100Class);
      el.classList.add(fullScreenClass);
    }
  };
  render() {
    const { showInput, userMessage, isIphoneX, username, total_brands } =
      this.state;
    return (
      <div id="page-container">
        <div className="heading_bar">
          <img
            src={logoImg}
            style={{ height: 30, marginLeft: 20 }}
            alt="logo"
          />
          {username && (
            <button
              type="button"
              className="btn nav-btn top-btn"
              id="page-header-notifications-dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-user" />
              <span className="badge badge-pill">{username}</span>
            </button>
          )}
        </div>
        <div style={{ height: 50 }}></div>
        <div
          className="message-list-wrapper"
          style={{
            padding: "16px 10px 10px",
          }}
          onLoad={this.applyHeight}
        >
          {this.setMessages()}
          <TransitionGroup component="div" className="message-input-container">
            {showInput ? (
              <MessageInput
                message={userMessage}
                addMessage={this.addMessage}
                isIphoneX={isIphoneX}
                brands={total_brands}
                history={this.props.history}
              />
            ) : null}
          </TransitionGroup>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    uid: state.uid,
    users: state.users,
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignUp));



// WEBPACK FOOTER //
// ./src/screens/SignUp/index.js